<template>
    <ModeSwitcher
        ref="modeSwitcher"
        :main-mode-text="$t('create')"
        :create-mode-text="$t('create_loyalty_program')"
        :edit-mode-text="$t('edit_loyalty_program')"
        class="pt-4"
        @reset="selectedLoyaltyId = null"
    >
        <template v-slot:btn-block>
            <div class="full-width d-flex align-center">
                <v-spacer />
                <FilterStatusToggle v-model="activeFilter" />
            </div>
        </template>
        <template v-slot:main-mode>
            <v-data-table
                :headers="useHeaders"
                :items="useLoyalty"
                :items-per-page-options="useTableOptions(useLoyalty.length)"
                :items-length="useLoyalty.length"
                density="compact"
                class="elevation-1 table-server"
                must-sort
                fixed-header
            >
                <template v-slot:item.name="{item}">
                    <span class="text-link" @click="editSalesSettings(item.id)">
                        {{ item.name }}
                    </span>
                </template>
                <template v-slot:item.active="{item}">
                    {{ item.active ? $t('active') : $t('inactive') }}
                </template>
            </v-data-table>
        </template>
        <template v-slot:additional-mode>
            <LoyaltySalesSettingsForm
                :loyalty-id="selectedLoyaltyId"
                @save="save()"
                @cancel="modeSwitcher.goToTable()"
            />
        </template>
    </ModeSwitcher>
</template>

<script setup lang="ts">
    import {useTableOptions} from '~/composables/helpers'

    const selectedLoyaltyId = ref<number>()
    const modeSwitcher = ref(null)
    const activeFilter = ref<boolean>(true)

    const {t} = useI18n()

    const {loyalties, load} = useLoyalties()

    const useHeaders = computed(() => {
        return [
            {title: t('name'), value: 'name', minWidth: '150px', sortable: true},
            {title: t('status'), value: 'active', width: '140px'},
        ]
    })

    const useLoyalty = computed(() => {
        return loyalties.value.filter(({active}) => activeFilter.value === active)
    })

    const editSalesSettings = (id: number): void => {
        selectedLoyaltyId.value = id
        modeSwitcher.value.edit()
    }

    const save = async (): Promise<void> => {
        modeSwitcher.value.goToTable()
        await load()
    }
</script>
